const normalizeBase = (raw: string | undefined, fallback: string) => {
  const trimmed = (raw || '').trim();
  const base = trimmed || fallback;
  return base.replace(/\/$/, '');
};

export const getApiBaseUrl = () => {
  // Default to same-origin API so Firebase-hosted frontend works without localhost.
  // Override via VITE_API_BASE_URL (can be '/api' or 'https://example.com/api').
  return normalizeBase(import.meta.env.VITE_API_BASE_URL, '/api');
};

export const getEngineBaseUrl = () => {
  // Default to same-origin engine routes.
  // Override via VITE_ENGINE_BASE_URL if needed.
  return normalizeBase(import.meta.env.VITE_ENGINE_BASE_URL, '');
};

export const isForceMockEnabled = () => {
  if (!import.meta.env.DEV) return false;

  const envEnabled = import.meta.env.VITE_FORCE_MOCK === 'true';

  // Optional runtime override for QA/dev without rebuilding.
  // (Still explicit; no silent fallback.)
  let storageEnabled = false;
  try {
    storageEnabled = typeof window !== 'undefined' && window.localStorage?.getItem('IW_FORCE_MOCK') === 'true';
  } catch {
    storageEnabled = false;
  }

  return envEnabled || storageEnabled;
};
